<template>
<div>
    <div style="display: flex;">
        <HeadDetailsGama :titleHead="'Detalhes do Cliente'"
        :AttachmentsDetails="true"
        :btnAnexDown="true"
        :btnSolicitacoes="selectedSolicitacao.status == 2 || selectedSolicitacao.status == 3"
        @cancelarSolicitacao="$emit('cancelarSolicitacao')"
        :btnPendencyApproveRequest="selectedSolicitacao.status == 4">
        </HeadDetailsGama>

        <b-modal ref="modalAttachtmentDetails" hide-footer  id="modal-center" centered title="comprovante"
          class="centralizatexto">
            <div v-show="isPdf">
              <iframe
                style="overflow: hidden"
                id="pdfViewer"
                scrolling="no"
                class="mb-2 img-body-body pdf-overview"
                :src="'data:application/pdf;base64,'+ imgDetails + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
              </iframe>
            </div>
            <div v-show="!isPdf">
              <img class="img-modal-details" :src="'data:image/jpeg;base64,' + imgDetails">
            </div>
            </b-modal>

    </div>
    <div class="searchDownload">
      <div id="searchDownloadDetails" class="pt-2" >
        <div class="w-50 searchBox">
          <input @keyup="pesquisar" class="form-control input-search w-100 h-100" v-model="search" placeholder="Pesquisar">
          <i class="fas fa-search icon-search"  aria-hidden="true"></i>
        </div>
        <div class="button-dowload">
          <button class="btn-download" v-on:click="downloadGrup"><i class="fas fa-download"></i></button>
        </div>
      </div>
    </div>
        <div class="" v-if="!searching">
          <CollapseImageDetails
          v-for="dataf in dataGruposMidias"
          v-bind:key="dataf.enum"
          :id="dataf.enum.toString()"
          :title="dataf.descricao"
          :group="dataf.enum"
          :dataImg="getTypes(dataf.enum)"
          v-on:imageDetails="imageDetails"
          v-on:download="download(data.enum)"
          :flAdd="verificarEditar(dataf)"
          >
          <input :id="'check' + dataf.enum" type="checkbox" :disabled="haveElements(getTypes(dataf.enum))" class="check-title">
          </CollapseImageDetails>
        </div>
        <div v-else class="img-flex pt-4">
            <div  v-for="dataimg in midiasSearch" v-bind:key="dataimg.id" class="p-3" >
              <div class="img-body">
                <div class="h-100 container-img-card" v-on:click="imageDetails(dataimg.arquivo.arquivo, (dataimg.arquivo.extensao == 'pdf'))">
                  <div class="img-title">{{dataimg.arquivo.descricao == null ? 'N/D' : dataimg.arquivo.descricao}}</div>
                    <img  v-if="!(dataimg.arquivo.extensao == 'pdf')" class="mb-2 img-body-body" :src="'data:image/png;base64,' + dataimg.arquivo.arquivo">
                    <i v-if="dataimg.arquivo.extensao == 'pdf'" style="font-size: 70px" class="fas fa-file-pdf"></i>
                    <div  class="img-footer">
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import AttachmentsDetails from './attachmentsDetails'
export default AttachmentsDetails
</script>

<style scoped>

  #searchDownloadDetails{
    display: flex;
    width: 100%;
  }
  .searchDownload{
    margin-top: 17px;
  }
  .button-dowload{
   display: flex;
   justify-content: end;
   width: 100%;
  }

  .btn-new-gru{

    height: 30px;
    width: 181px;
    background: white;
    font-size: 14px;
    color: #008148;
    font-weight: bold;
    border: 1px solid #008148;
    margin: 0px;
    border-radius: 6px;

  }
  .btn-new-gru:hover{

    color: white;
    background: #008148;

  }

  .btn-download{
    height: 30px;
    width: 53px;
    background-color: #008148;
    border: none;
    color: white;
    border-radius: 6px;
  }

  .btn-download:hover{
  background-color: #01683a;
  }

  .head-attach{
    display: flex;
    height: 50px;
    justify-content: space-between;
  }
  .check-title{
    height: 20px;
    width: 20px;
    position: absolute;
    top: 8px;
    left: 5px;
    padding-left: 20px;
  }
  .attach{
    font-size: 18px;
    color: black;
    padding-top: 16px;
    padding-left: 15px;
    font-weight: bold;
  }
  .arrow-angel{
    padding-top: 10px;
    font-size: 30px;
    color: black;
    padding-right: 24px;
  }

  .searchAndDownload{
    display: flex;
    justify-content: space-between;
  }

  #searchField{
    width: 397px;
    height: 37px;
    border-radius: 4px;
    border: none;
  }

  .searchBox{
    position: relative;
  }
  .icon-search{
    position: absolute;
    top:  10px;
    left: 10px;
  }
  .input-search{
    padding-left: 28px;
  }
  .img-modal-details{
  height: 400px;
  object-fit: cover;
  width: 100%;
  }

  .container-img-card {
  display: flex;
  justify-content: center;
  align-items: center;
  }
  .pdf-view{
    height: 408px;
  }

  .pdf-overview{
    height: 657px;
  }

  .img-body{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
}

.img-body-view-pdf{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
}

#pdfViewer{
  position: relative;
  height: 640px;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/attachmentsDetails/attachmentsDetails.vue